var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12505 0C11.4875 0 13.7375 0.9 15.5375 2.5875C17.225 4.3875 18.125 6.6375 18.125 9C18.125 11.3625 17.225 13.6125 15.5375 15.4125C13.7375 17.1 11.4875 18 9.12505 18C6.76255 18 4.51255 17.1 2.71255 15.3C-0.774951 11.8125 -0.774951 6.075 2.71255 2.5875C4.51255 0.9 6.76255 0 9.12505 0ZM9.12505 16.875C11.2625 16.875 13.175 16.0875 14.75 14.625C16.2125 13.05 17 11.1375 17 9C17 6.8625 16.2125 4.95 14.75 3.4875C13.175 1.9125 11.2625 1.125 9.12505 1.125C6.98755 1.125 5.07505 1.9125 3.50005 3.375C0.462549 6.525 0.462549 11.475 3.50005 14.625C5.07505 16.0875 6.98755 16.875 9.12505 16.875Z",
    fill: "#00AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2501 13.1625H9.68756V7.875C9.68756 7.5375 9.46256 7.3125 9.12506 7.3125H8.00006C7.66256 7.3125 7.43756 7.5375 7.43756 7.875C7.43756 8.2125 7.66256 8.4375 8.00006 8.4375H8.67506V13.1625H8.00006C7.66256 13.1625 7.43756 13.3875 7.43756 13.725C7.43756 14.0625 7.66256 14.2875 8.00006 14.2875H10.2501C10.5876 14.2875 10.8126 14.0625 10.8126 13.725C10.8126 13.3875 10.5876 13.1625 10.2501 13.1625Z",
    fill: "#00AEEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5875 4.95C10.5875 5.7375 9.91254 6.4125 9.12504 6.4125C8.33754 6.4125 7.66254 5.85 7.66254 4.95C7.66254 4.05 8.33754 3.4875 9.12504 3.4875C9.91254 3.4875 10.5875 4.1625 10.5875 4.95ZM9.57504 4.8375C9.57504 4.6125 9.35004 4.3875 9.12504 4.3875C8.90004 4.3875 8.67504 4.6125 8.67504 4.8375C8.67504 5.0625 8.90004 5.2875 9.12504 5.2875C9.35004 5.2875 9.57504 5.0625 9.57504 4.8375Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.98020d0194a4573dc9832dadce6c440c.svg";
export { ForwardRef as ReactComponent };